module.exports = __webpack_public_path__ + "media/images/admin/icons/git-branch-120adf52f8c4855276742c1d33c5b94f.svg";